import React, { useMemo } from 'react';
import { addDays, format } from 'date-fns';
import { DatePill } from '../../primitives/DatePill';
import { Icon } from '../../primitives/Icon';
import { formatDate, isToday } from '../../../../utils/dateUtils';
import '../../../../styles/components/date-quick-select.css';

const DAYS_TO_SHOW = 7;

interface DateQuickSelectBarProps {
  selectedDates: string[];
  onDateToggle: (date: string) => void;
  onOpenFilters: () => void;
  className?: string;
}

const DateQuickSelectBarInner: React.FC<DateQuickSelectBarProps> = ({
  selectedDates,
  onDateToggle,
  onOpenFilters,
  className = ''
}) => {
  const dates = useMemo(() => {
    const today = new Date();
    return Array.from({ length: DAYS_TO_SHOW }, (_, i) => {
      const date = addDays(today, i);
      const isTodayDate = isToday(date);
      return {
        dateStr: formatDate(date),
        dayOfWeek: format(date, 'EEE'),
        dayNumber: format(date, 'd'),
        isToday: isTodayDate,
        label: isTodayDate ? 'Today' : undefined
      };
    });
  }, []);

  return (
    <div className={`date-quick-select ${className}`} data-quick-select>
      <div className="date-quick-select__scroll">
        {dates.map(({ dateStr, dayOfWeek, dayNumber, isToday: isTodayDate, label }) => (
          <DatePill
            key={dateStr}
            dayOfWeek={dayOfWeek}
            dayNumber={dayNumber}
            isToday={isTodayDate}
            isSelected={selectedDates.includes(dateStr)}
            label={label}
            onClick={() => onDateToggle(dateStr)}
          />
        ))}
      </div>

      <button
        className="date-quick-select__filter-btn"
        onClick={onOpenFilters}
        aria-label="Open date filters"
      >
        <Icon name="SlidersHorizontal" size={20} />
      </button>
    </div>
  );
};

export const DateQuickSelectBar = React.memo(DateQuickSelectBarInner);
